/* global exports */
"use strict";

export var imgixUrl = Skubacz.configuration.imgix_url;
